<template>
  <div class="editor-page eventi">
    <loader
      v-if="item == null || loading"
      :show="item == null"
      :width="40"
      :height="40"
    ></loader>
    <top-bar
      v-if="item != null"
      :title="id == 'new' ? 'Inserimento evento' : 'Modifica evento'"
      :preview="item.contents[lang].permalink + '?preview=1'"
      :action="`Salva`"
      :actionIsValid="isValid"
      :loading="loading || item == null"
      @lang="
        (l) => {
          lang = l;
          $v.$touch();
        }
      "
      @onAction="save"
    ></top-bar>
    <div v-if="item && item.draft > 0">
      <div class="alert alert-info alert-with-icon">
        <button type="button" aria-hidden="true" class="close">×</button>
        <span data-notify="icon" class="ti-bell"></span>
        <span data-notify="message">Scheda BOZZA di Revisione</span>
      </div>
    </div>
    <form :class="['form', 'row']" novalidate v-if="item != null">
      <div class="col-md-9">
        <card title="Informazioni di base" :collapse="false">
          <content>
            <textbox
              title="Titolo"
              :v="$v.item.contents[lang].title"
              v-model="item.contents[lang].title"
              @blur="
                item.contents[lang].slug =
                  item.contents[lang].slug ||
                  item.contents[lang].title.slugify()
              "
            />
            <textbox
              title="Slug"
              :v="$v.item.contents[lang].slug"
              v-model="item.contents[lang].slug"
            />
            <textbox
              title="Sottotitolo"
              :maxLength="140"
              v-model="item.contents[lang].subtitle"
            />
            <div class="form-group">
              <h5>Descrizione</h5>
              <rich-editor
                :v="$v.item.contents[lang].description"
                v-model="item.contents[lang].description"
              />
            </div>
            <div class="form-group">
              <label>Tags</label>
              <tag-manager
                aria-required="false"
                aria-invalid="false"
                v-model="item.contents[lang].tags"
                :canAddTags="canAddTags"
                :language="lang"
              />
            </div>
          </content>
        </card>



        <card title="Indirizzo" :collapse="false">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Destinazione</label>
              <destination-combo
                required="true"
                aria-required="true"
                aria-invalid="false"
                v-model="item.location.destination"
              />
            </div>
          </div>
          <address-box v-model="item.location"></address-box> </card
        ><!-- indirizzo -->

        <card title="Date" :collapse="false">
          <advanced-date-picker
            v-model="item.dates"
            :lang="lang"
          ></advanced-date-picker>

          <date-picker
            v-model="item.inauguration"
            label="Data e ora dell'inaugurazione"
          ></date-picker>

        </card>

        <card title="Orari" :collapse="false">
          <advanced-time-picker
            v-model="item.times"
            :lang="lang"
          ></advanced-time-picker>
        </card>

        <card title="Ticket" :collapse="false">
          <ticket-box v-model="item.ticketing" :lang="lang"></ticket-box>
        </card>

        <card title="Contatti" :collapse="false">
          <contacts-editor
            v-model="item.contacts[lang]"
            :lang="lang"
          ></contacts-editor>
        </card>

        <card title="Immagini" :collapse="false">
          <attachments-box v-model="item.attachments"></attachments-box>
        </card>

                <card title="Seo" :collapse="true">
          <textbox
            title="Keywords"
            v-model="item.contents[lang].google.keywords"
          />
          <textbox title="Title" v-model="item.contents[lang].google.title" />
          <a-textarea
            title="Meta Descrizione"
            :maxLength="160"
            v-model="item.contents[lang].google.description"
          />
        </card>

        <card title="Social" :collapse="true">
          <textbox
            title="Titolo per social"
            v-model="item.contents[lang].social.title"
          />
          <a-textarea
            title="Descrizione per social"
            :maxLength="160"
            v-model="item.contents[lang].social.description"
          />
        </card>
      </div>
      <div class="col-md-3">
        <card title="Impostazioni">
          <statuses-box
            ref="sbox"
            v-model="item.contents[lang].status"
            title="false"
            :lang="lang"
            :entity="item.id"
            :statuses="item.nextStatuses[lang]"
          ></statuses-box
          ><!-- stato -->
          <author-box v-model="item.contents[lang].author"></author-box>
          <date-picker v-model="item.contents[lang].pub_date"></date-picker>
        </card>
        <card title="Categoria" :collapse="false">
            <category-combo
              :mainCategory="1"
              v-model="item.category"
            ></category-combo>
        </card>
        <card title="Interessi" :collapse="false">
            <category-combo
              :mainCategory="5"
              v-model="item.theme"
            ></category-combo>
        </card>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import Textbox from "@/components/altrama/form/Textbox";
import ATextarea from "@/components/altrama/form/ATextarea";
import RichEditor from "@/components/altrama/RichEditor";
import TagManager from "@/components/altrama/TagManager";
import CategoryCombo from "@/components/altrama/CategoryCombo";
import ContactsEditor from "@/components/altrama/ContactsEditor";
import AuthorBox from "@/components/altrama/AuthorBox";
import StatusesBox from "@/components/altrama/StatusesBox";
import DatePicker from "@/components/altrama/DatePicker";
import AdvancedDatePicker from "@/components/altrama/AdvancedDatePicker";
import AdvancedTimePicker from "@/components/altrama/AdvancedTimePicker";
import TicketBox from "@/components/altrama/TicketBox";
import TappeBox from "@/components/altrama/TappeBox";
import AttachmentsBox from "@/components/altrama/AttachmentsBox";
import AddressBox from "@/components/altrama/AddressBox";
import CityCombo from "@/components/altrama/CityCombo";
import CityComboMultiselect from "@/components/altrama/CityComboMultiselect";
import DestinationCombo from "@/components/altrama/DestinationCombo";
import TopBar from "@/components/altrama/TopBar";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["id"],
  mixins: [validationMixin],
  validations() {
    if (
      !!this.item &&
      !!this.item.contents[this.lang] &&
      this.item.contents[this.lang].status == 1
    ) {
      return {
        item: {
          contents: this.$contentTemplate({
            title: { required },
            description: { required },
            excerpt: { required },
            slug: { required },
          }),
        },
      };
    }
    return {
      item: {
        contents: this.$contentTemplate({
          title: { required },
          description: "",
          excerpt: "",
          google: {
            keywords: "",
            description: "",
            title: "",
          },
          slug: "",
          social: {
            description: "",
            title: "",
          },
          subtitle: "",
        }),
      },
    };
  },
  data() {
    return {
      canAddTags: false,
      needSave: false,
      hasErrors: false,
      loading: true,
      item: null,
      lang: "it",
    };
  },
  computed: {
    isValid: function () {
      if (!this.item.canSave) {
        if (this.item.contents[this.lang].status == 1) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },
    template: function () {
      const userId = Number(this.$api.user.current().id);
      return {
        id: "new",
        contents: this.$contentTemplate({
          description: "",
          excerpt: "",
          google: {
            keywords: "",
            description: "",
            title: "",
          },
          slug: "",
          social: {
            description: "",
            title: "",
          },
          subtitle: "",
          title: "",
          tags: [],
          author: userId,
          status: 2,
          permalink: "",
          pub_date: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        }),
        location: {},
        dates: {
        },
        inauguration: null,
        times: {},
        contacts: this.$contentTemplate([]),
        category: [],
        attachments: [],
        ticketing: {},
        target: [],
        theme: [],
        nextStatuses: this.$contentTemplate(null),
        canSave: true,
        created_at: "",
        updated_at: "",
      };
    },
  },
  methods: {
    save: _.debounce(function () {
      this.$v.$touch();
      if (!this.$v.item.contents[this.lang].$anyError) {
        let self = this;
        let url = `${self.$url}event/${self.item.id}`;
        let method = "put";

        if (this.item.id == "new") {
          method = "post";
          url = `${self.$url}event`;
        }

        this.item.lang = this.lang;
        this.loading = true;

        axios({
          method: method,
          url: url,
          headers: this.$config.axiosHeaders(),
          data: this.item,
        })
          .then(function (response) {
            self.loading = false;
            self.$notifyVue(
              "top",
              "center",
              response.data.status,
              response.data.data.message,
              "ti-check"
            );
            self.$refs.sbox.update();
            if (response.data.data.id !== self.item.id) {
              self.item.id = response.data.data.id;
              self.$router.push({ params: { id: self.item.id } });
            }
            self.item.contents[self.lang].permalink =
              response.data.data.permalink + "?preview=1";
          })
          .catch(function (error) {
            self.loading = false;
            self.hasErrors = true;
            self.$processError(error);
          });

        this.needSave = false;
      }
    }, 300),
    loadData: function () {
      let self = this;
      self.item = null;

      if (this.item && this.id == this.item.id) {
        console.log("Ricaricamento della stessa pagina");
        return;
      }

      if (this.id == "new") {
        self.item = JSON.parse(JSON.stringify(self.template));
        self.needSave = false;
        self.loading = false;
        return;
      }

      self.loading = true;
      axios({
        method: "get",
        url: `${self.$url}event/${self.id}`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.item = _.merge(
            JSON.parse(JSON.stringify(self.template)),
            response.data.data
          );
          self.loading = false;
          self.needSave = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.hasErrors = true;
          self.$processError(error);
        });
    },
  },
  mounted: async function () {
    this.canAddTags = await this.$api.user.can("view-tag");
    this.loadData();
  },
  watch: {
    id: {
      handler(val, oldVal) {
        this.loadData();
      },
      deep: true,
    },
  },
  components: {
    RichEditor,
    TagManager,
    CategoryCombo,
    ContactsEditor,
    AuthorBox,
    StatusesBox,
    DatePicker,
    AdvancedDatePicker,
    AdvancedTimePicker,
    AttachmentsBox,
    TappeBox,
    TicketBox,
    TopBar,
    Textbox,
    ATextarea,
    AddressBox,
    CityCombo,
    CityComboMultiselect,
    DestinationCombo,
  },
};
</script>

<style>
.custom_tag {
  display: inline-block;
  padding: 3px 12px;
  background: #b7bce3;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
}

.custom_remove {
  padding: 0;
  font-size: 10px;
  margin-left: 5px;
}
</style>
